import { axios as request } from "../../request/http";

const interfaceUrl = {
  "api_orderList": "/order/query/list", // 订单列表
  "api_orderDetail": "/order/query/detail", // 订单详情
  "api_orderEditRemark": "/order/opt/editRemark", // 添加备注
  "api_orderEditAddress": "/order/opt/editAddress" ,// 修改收货 
  "api_orderCancel":"/order/opt/cancel",//取消订单
  "api_orderApprove":"/order/opt/approve",//审核订单
}

// initial state
const state = {
  orderList: {},
  orderDetail: {},
}

// getters
const getters = {
  getOrderList: state => {
    return state.orderList
  },
  getOrderDetail: state => {
    return state.orderDetail
  }
}

// actions
const actions = {
  getOrderList: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_orderList,
      method: "POST",
      data: params,
    };
    return request(option).then(res => res.data).then(res => {
      if (res.code == 200) {
        commit('ORDER_LIST', res || {});
      } else {
        commit('ORDER_LIST', {});
      }
    }).catch(err => {
      commit('ORDER_LIST', {});
    })
  },
  getOrderDetail: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_orderDetail,
      method: "GET",
      params,
    };
    return request(option).then(res => res.data).then(res => {
      if (res.code == 200) {
        commit('ORDER_DETAIL', res.data || {});
      } else {
        commit('ORDER_DETAIL', {});
      }
    }).catch(err => {
      commit('ORDER_DETAIL', {});
    })
  },
  orderEditRemark: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_orderEditRemark,
      method: "POST",
      params,
    };
    return request(option).then(res => res.data)
  },
  // 取消订单
  orderCancel: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_orderCancel,
      method: "POST",
      params,
    };
    return request(option).then(res => res.data)
  },
  // 审核订单
  orderApprove:({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_orderApprove,
      method: "POST",
      params,
    };
    return request(option).then(res => res.data)
  },
  orderEditAddress: ({
    commit,
    state
  }, params) => {
    params = params || {};
    let option = {
      url: interfaceUrl.api_orderEditAddress,
      method: "GET",
      params,
    };
    return request(option).then(res => res.data)
  },
}


// mutations
const mutations = {
  ORDER_LIST: (state, pageData) => {
    state.orderList = pageData;
  },
  ORDER_DETAIL: (state, pageData) => {
    state.orderDetail = pageData;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/order.js